module.exports = __webpack_public_path__ + "img/banner-mobile.ce7ad90c.png";